export default __webpack_public_path__ + "static/media/arrow-down.ba1e11cf.svg";